import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core'
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

const useStyles = makeStyles((theme) => ({
    controledField: {
        width: '100%',
        margin: 0
    },
    headerText: {
        marginBottom: 40
    },
    formControl: {
        marginBottom: 0
    },
    difficultyBox: {
        flexDirection: 'row',
        alignItems: 'center'
    }
})
)

const SelectChipOption = ({ fieldValue, handleFieldValue, label, fieldLabel, fieldOptions }) => {
    const classes = useStyles();
    let returnedOptions = []

    const handleChange = (value) => {
        returnedOptions = [...fieldValue]
        let checkSelection = returnedOptions.indexOf(value)
        if ((checkSelection === -1) && (value !== "")) {
        returnedOptions.push(value)
        handleFieldValue(returnedOptions)}
    }

    return (
        <>
            <Typography gutterBottom variant="body1" component="span" className="boxLabel">
                {label}:
            </Typography>
            <FormControl variant="outlined" className={classes.controledField}>
                <Select
                onChange={(e) => handleChange(e.target.value)}
                displayEmpty
                className={classes.selectEmpty}
                inputProps={{ 'aria-label': 'Without label' }}
                >
                    <MenuItem value={fieldValue._id} disabled>
                        {fieldLabel}
                    </MenuItem>
                    {fieldOptions.map(option => <MenuItem value={option.key}>
                        {option.label}
                    </MenuItem>)}
                </Select>
            </FormControl>
        </>
    )
}

export default SelectChipOption 